'use client';

import Link from 'next/link';
import { Twitter, Linkedin, Facebook, Instagram } from 'lucide-react';

const footerLinks = {
 product: [
 { name: 'Features', href: '#features' },
 { name: 'Pricing', href: '#pricing' },
 { name: 'How It Works', href: '#how-it-works' },
 { name: 'Screenshots', href: '#screenshots' },
 ],
 company: [
 { name: 'About', href: 'https://dovepeakdigital.com/about' },
 { name: 'Blog', href: 'https://dovepeakdigital.com/blog' },
 { name: 'Careers', href: 'https://dovepeakdigital.com/careers' },
 { name: 'Contact', href: 'https://dovepeakdigital.com/contact' },
 ],
 support: [
 { name: 'Help Center', href: '#' },
 { name: 'API Docs', href: '#' },
 { name: 'Status', href: '#' },
 { name: 'Community', href: '#' },
 ],
 legal: [
 { name: 'Privacy Policy', href: '/legal/privacy' },
 { name: 'Terms of Service', href: '/legal/terms' },
 { name: 'Cookie Policy', href: '/legal/cookies' },
 { name: 'GDPR', href: '/legal/gdpr' },
 ],
};

const socialLinks = [
 { name: 'Twitter', icon: <Twitter size={20} />, href: '#' },
 { name: 'LinkedIn', icon: <Linkedin size={20} />, href: '#' },
 { name: 'Facebook', icon: <Facebook size={20} />, href: '#' },
 { name: 'Instagram', icon: <Instagram size={20} />, href: '#' },
];

export default function FooterSection() {
 return (
 <footer className="bg-white border-t border-gray-100 py-16 px-4 sm:px-6 lg:px-8">
 <div className="max-w-7xl mx-auto">
 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 lg:gap-8">
 {/* Company Info */}
 <div className="lg:col-span-2">
 <Link href="/" className="flex items-center gap-2 mb-6">
 <img src="/assets/logo.png" alt="InvoiceFlow" className="h-8 w-auto" />
 <span className="text-xl font-bold tracking-tight text-gray-900">InvoiceFlow</span>
 </Link>
 <p className="text-gray-500 font-medium mb-8 max-w-sm leading-relaxed">
 Streamline your invoicing process with our modern, easy-to-use platform designed for businesses and freelancers worldwide.
 </p>
 <div className="flex space-x-3">
 {socialLinks.map((social) => (
 <a
 key={social.name}
 href={social.href}
 className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-indigo-600 hover:text-white transition-all duration-300"
 target="_blank"
 rel="noopener noreferrer"
 >
 {social.icon}
 </a>
 ))}
 </div>
 </div>

 {/* Links Groups */}
 <div>
 <h3 className="text-sm font-bold text-gray-900 font-medium mb-6">Product</h3>
 <ul className="space-y-4">
 {footerLinks.product.map((link) => (
 <li key={link.name}>
 <Link href={link.href} className="text-gray-500 font-medium hover:text-indigo-600 transition-colors">
 {link.name}
 </Link>
 </li>
 ))}
 </ul>
 </div>

 <div>
 <h3 className="text-sm font-bold text-gray-900 font-medium mb-6">Company</h3>
 <ul className="space-y-4">
 {footerLinks.company.map((link) => (
 <li key={link.name}>
 <Link 
   href={link.href} 
   className="text-gray-500 font-medium hover:text-indigo-600 transition-colors"
   {...(link.href.startsWith('http') ? { target: "_blank", rel: "noopener noreferrer" } : {})}
 >
 {link.name}
 </Link>
 </li>
 ))}
 </ul>
 </div>

 <div>
 <h3 className="text-sm font-bold text-gray-900 font-medium mb-6">Support</h3>
 <ul className="space-y-4">
 {footerLinks.support.map((link) => (
 <li key={link.name}>
 <Link href={link.href} className="text-gray-500 font-medium hover:text-indigo-600 transition-colors">
 {link.name}
 </Link>
 </li>
 ))}
 </ul>
 </div>

 <div>
 <h3 className="text-sm font-bold text-gray-900 font-medium mb-6">Legal</h3>
 <ul className="space-y-4">
 {footerLinks.legal.map((link) => (
 <li key={link.name}>
 <Link href={link.href} className="text-gray-500 font-medium hover:text-indigo-600 transition-colors">
 {link.name}
 </Link>
 </li>
 ))}
 </ul>
 </div>
 </div>

 <div className="border-t border-gray-50 mt-16 pt-8 flex flex-col md:flex-row justify-center items-center gap-4">
 <p className="text-gray-400 text-sm font-medium">
 © 2024 InvoiceFlow. All rights reserved.
 </p>
 </div>
 </div>
 </footer>
 );
}